import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import type { PaginationState, Updater } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'
import { useVouchersReportList } from '@/shared/api/vaucher-report'
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE, PERMISSION_SUB_MODULES } from '@/shared/const'
import { useFilters } from '@/shared/hooks/use-filters'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { ReportsWidget } from '@/widgets/reports-widget'

export const Route = createFileRoute('/_auth/reports/vouchers')({
  staticData: {
    meta: {
      title: 'Отчет по ваучерам',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { filters, setFilters } = useFilters(Route.id)

  const { data, isLoading, isError } = useVouchersReportList({
    ...filters,
    'pagination.page': filters?.['pagination.page'] ?? DEFAULT_PAGE_INDEX,
    'pagination.pageSize': filters?.['pagination.pageSize'] ?? DEFAULT_PAGE_SIZE,
  })

  const paginationState = {
    pageIndex: filters?.['pagination.page'] ?? DEFAULT_PAGE_INDEX,
    pageSize: filters?.['pagination.pageSize'] ?? DEFAULT_PAGE_SIZE,
  }

  const handlePaginationChange = (pagination: Updater<PaginationState>) => {
    if (typeof pagination === 'function') {
      const newPagination = pagination(paginationState)
      setFilters({
        'pagination.page': newPagination.pageIndex,
        'pagination.pageSize': newPagination.pageSize,
      })
    } else {
      setFilters({
        'pagination.page': pagination.pageIndex,
        'pagination.pageSize': pagination.pageSize,
      })
    }
  }

  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.VOUCHER_REPORT_SCHOOL}>
      <PageWrapper title={t('Отчет по ваучерам')}>
        <ReportsWidget
          reportList={data?.reports ?? []}
          isLoading={isLoading}
          isError={isError}
          total={data?.total}
          reportType="voucher"
          pagination={paginationState}
          onPaginationChange={handlePaginationChange}
          routeId={Route.id}
          onRowClick={(row) => {
            navigate({
              to: '/reports/vouchers/item/$reportId',
              params: { reportId: row.id },
            })
          }}
        />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
